module.exports = __webpack_public_path__ + "static/pyramids_alien_drawing2-c87a97b6c134454f58dc88d074e3bdfe.png";